module.exports = __webpack_public_path__ + "static/media/english-flag.5a0d5d3c.svg";